import { render } from "./BatchItem.vue?vue&type=template&id=a137ce1e&scoped=true&ts=true"
import script from "./BatchItem.vue?vue&type=script&lang=ts"
export * from "./BatchItem.vue?vue&type=script&lang=ts"

import "./BatchItem.vue?vue&type=style&index=0&id=a137ce1e&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a137ce1e"]])

export default __exports__